<template>
	<v-container 
		fluid
		class="white"
		:class="$vuetify.breakpoint.xs ? '':'leavecalc ma-4 pa-3'"
	>
		<template v-if="!isLeaveCreating">
			<v-row no-gutters>
				<v-col cols="12" class="px-2 py-3">
					<div 
						class="float_left v-label theme--light"
						style="color:#C18014;font-weight: 500"
					>
						Calculate Leave
					</div>
				</v-col>
			</v-row>
			<v-alert class="mx-1 mb-0" type="error" v-if="error_msg.length !== 0">
				{{ error_msg }}
			</v-alert>
			<ProgressLinear v-if="loading"/>
			<v-row 
				v-if="!loading && hasdata"
				no-gutters 
				class="grey lighten-3 px-5 py-2" 
			>
				<v-col cols="3" class="pr-3">
					<div class="calc_label text-caption">
						Available
					</div>
					<div class="calc_content light-blue--text">
						{{ current_balance }}
					</div>
					<div class="calc_label text-caption">
						Current balance
					</div>
				</v-col>
				<v-col cols="3" class="pr-3">
					<div class="calc_label text-caption">Available</div>
					<div class="calc_content">{{ leave_by_date }}</div>
					<div class="calc_label text-caption">by Start Date</div>
				</v-col>
				<v-col cols="3" class="pr-3">
					<div class="calc_label text-caption">Leave Requested</div>
					<div class="calc_content">{{ leave_requested }}</div>
				</v-col>
				<v-col cols="3" class="pl-2">
					<div class="calc_label text-caption">Remaining Leave</div>
					<div class="calc_content" v-if="is_negative" style="color:#FF0000">- {{ leave_remaining}}</div>
					<div class="calc_content" v-if="!is_negative">{{ leave_remaining }}</div>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col :cols="$vuetify.breakpoint.smAndDown? 12:9" class="pa-2">
					<v-select
						label="Leave Type"
						v-model="event_type"
						:color="$attrs.color"
						:item-color="$attrs.color"
						:items="filtered_leavetypes"
						item-text="desc"
						item-value="id"
						hide-details
						return-object
					>
					</v-select>
				</v-col>
			</v-row>
			<v-row class="mt-1" no-gutters>
				<v-col cols="12" class="pa-2">
					<DateMulti
						:lableText="'Start date to End date'"
						:color="$attrs.color"
						:dateStartInit="date_init"
						:dateEndInit="date_init"
						:background="`#FAFAFA`"
						@dateRange="onDateChange($event)"
					/>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<DateTime
					:color="$attrs.color"
					:startTimeInit="time_start_init"
					:endTimeInit="time_end_init"
					:startError="start_time_error"
					:endError="end_time_error"
					:errorEndFlag="time_required"
					:disabled="!time_able"
					:styleLeft="`pa-2`"
					:styleRight="`pa-2`"
					@time_start="onTimeStartChange($event)"
					@time_end="onTimeEndChange($event)"
				/>
			</v-row>
			<v-row no-gutters class="mt-2">
				<v-col cols="12" class="white pa-2">
					<v-btn 
						block
						class="white--text"
						color="#00AAFD" 
						@click="onCalculate()"  
						:disabled="!isCalulate"
					>
						Calculate
					</v-btn>
				</v-col>
			</v-row>
			<v-row class="mt-0 mb-1 justify-center" >
				<v-btn 
					text
					class="text-capitalize" 
					color="#192a3e"
					@click="reset_leave()" 
					:disabled="!leaves"
				>
					Reset fields
				</v-btn>
				<v-btn 
					text
					class="text-capitalize"
					color="#00AAFD" 
					@click="create_leave()"  
					:disabled="loading || !isCalulate"
				>
					Request Leave
				</v-btn>
			</v-row>
		</template>
		<CreateLeave
			v-if="isLeaveCreating"
			:leaveType="event_type"
			:startDate="date_start"
			:endDate="date_end"
			:partialLeave="date_start === date_end && time_start.length !== 0 && time_end.length !== 0"
			:partDate="date_start"
			:startTime="time_start"
			:endTime="time_end"
			:color="$attrs.color"
		/>
	</v-container>
</template>

<script>
import DateMulti from "@/components/date/date_multi.vue";
import ProgressLinear from "@/components/progress/progress_getdata_linear";
import CreateLeave from "@/views/leave/leave_edit.vue";
import DateTime from "@/components/date/date_time.vue";

//mixin
import { metaMixin } from "@/mixins/leave/metaMixin";
import { validTime } from "@/common/validTime.js";
import moment from 'moment';

const Date_Type = {
	date_start: 'start',
	date_end: 'end'
};


export default {
	name: 'LeaveCalculator',
	mixins: [ metaMixin ],
	data() {
		this.date_type = Date_Type;

		return {
			loading: false,
			error_msg:'',

			date_init: moment().format("YYYY-MM-DD"),

			date_start: moment().format("YYYY-MM-DD"),
			date_end:  moment().format("YYYY-MM-DD"),
			time_start: '9:00 am',
			time_end: '5:00 pm',
			time_start_init: '9:00 am',
			time_end_init: '5:00 pm',

			start_time_error: false,
			end_time_error: false,

			event_type: null,
			isCalulate: false,

			leaves: null,
			current_balance:'8h',
			leave_by_date:'8h',
			leave_requested:'8h',
			leave_remaining:'8h',
			is_negative: false,
			leave_capacity: 0,

			hasdata: false,
			isLeaveCreating: false,
		}
	},
	components: {
		DateMulti,
		ProgressLinear,
		CreateLeave,
		DateTime
	},
	created() {
		this.load_meta_data();

		//add this page to our breadcumb
		this.$store.commit('push_breadcrumb', {
			exact: true,
			text: 'Leave Calculator',
			to: this.$route.path,
		});
	},
	computed: {
		filtered_leavetypes(){
			let filtered = [];

			if (this.event_types.length !== 0) {
				const leave_order = ['annual leave', 'personal leave', 'unpaid leave', 'long service leave'];

				const order_leave_arr = [];
				leave_order.forEach(leave => {
					const arr = this.event_types.filter(e => { return e.desc.toLowerCase() === leave })
					order_leave_arr.push(arr[0])
				});

				const unorder_leave_arr = this.event_types.filter(type => { return !leave_order.includes(type.desc.toLowerCase())})

				filtered = [...order_leave_arr, ...unorder_leave_arr];

				/**  leave_type=1, annual leave; leave_type=4, long service leave */
				filtered = filtered.filter(e => { return e.leave_type === 1 || e.leave_type === 4 });
			}

			return filtered;
		},
		user() {
			return this.$store.state.user;
		},
		time_able() {
			let able = false;

			if (this.date_start && this.date_start.length !== 0 && this.date_end && this.date_end.length !== 0 && this.date_start === this.date_end) {
				able = true;
			}

			return able;
		},
		time_required() {
			let is_required = false;

			if (this.date_start && this.date_start.length !== 0 && this.date_end && this.date_end.length !== 0 && this.date_start === this.date_end) {
				if (this.time_start && this.time_start.length !== 0 && !this.time_end) {
					is_required = true;
				}
			}
			
			return is_required;
		}
	},
	watch: {
		date_start() {
			this.isCalulate = this._isCalulate();
		},
		date_end() {
			this.isCalulate = this._isCalulate();
		},
		event_type() {
			this.isCalulate = this._isCalulate();
		},
		time_start() {
			this.isCalulate = this._isCalulate();
		},
		time_end() {
			this.isCalulate = this._isCalulate();
		},
		leaves() {
			if (this.leaves && !this.loading) {
				this.hasdata = true;
				this.format_availableLeave();
			}
		}
	},
	methods: {
		async onCalculate() {
			this.error_msg = '';

			if(!this.user) return;

			if (this.user.addressbook === null) {
				this.error_msg = "Your user account is not linked to an employee record...";
				return;
			}
			const all_day = (this.date_start !== this.date_end && this.date_end) || (this.date_start === this.date_end && this.time_start.length === 0 && this.time_end.length === 0) ? true : false;
			const partial_leave = !all_day;

			if (partial_leave) {
				await this.getLeaves(this.date_start);
			} else {
				await this.getCapacity();
				await this.getLeaves(this.date_start);
			}
		},
		async getLeaves(date) {
			this.loading = true;

			const params = [];
			params.push("employee=" + this.user.addressbook.id);
			params.push("event_type=" + this.event_type.id);
			params.push('date='+ date);

			let url = "/api/leave/available";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === 'string') {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status === 'OK') {
						this.leaves = data;
						this.loading = false;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		async getCapacity() {
			this.loading = true;

			const params = [];
			params.push('from_date='+ this.date_start);
			params.push('to_date='+ this.date_end);

			let url = `/api/addressbook/${this.user.addressbook.id}/capacity`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status === 'OK') {
						this.leave_capacity = data.capacity - data.leave;
						this.loading = false;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		onDateChange(value) {
			this.error_msg = '';

			if (value.length === 0) {
				this.date_start = '';
				this.date_end = '';
				this.time_start = '';
				this.time_end = '';
				this.time_start_init = '';
				this.time_end_init = '';
			}

			if (value.length === 2) {
				if ((this.date_start && value[0] !== this.date_start) || (this.date_end && value[1] !== this.date_end)) {
					this.time_start = '';
					this.time_end = '';
					this.time_start_init = '';
					this.time_end_init = '';
				}

				this.date_start = value[0];
				this.date_end = value[1];
				
				if (this.date_start && this.date_end && this.date_start.length !== 0 && this.date_end.length !== 0 && this.date_start !== this.date_end) {
					this.time_start = '';
					this.time_end = '';
					this.time_start_init = '';
					this.time_end_init = '';
				}
			}
			
			this.isCalulate = this._isCalulate();
		},
		onTimeStartChange(time) {
			this.error_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_start = time;

			this._timeCheck(true);

			this.isCalulate = this._isCalulate();
		},
		onTimeEndChange(time) {
			this.error_msg = '';
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_end = time;

			this._timeCheck(false);

			this.isCalulate = this._isCalulate();
		},
		format_availableLeave() {
			this.current_balance = '';
			this.leave_by_date = '';
			this.leave_requested = '';
			this.leave_remaining =  '';
			this.is_negative = false;

			//Leave as of today
			const current_leave = this.leaves.current_leave;
			const current_leave_positive = Math.abs(current_leave);
			const curr_days = Math.floor(current_leave_positive / this.leaves.mins_per_day);
			const current_leave_left = current_leave_positive - (curr_days * this.leaves.mins_per_day);

			const curr_hrs = Math.floor(current_leave_left / 60);
			const curr_mins = current_leave_left - (curr_hrs * 60);
			
			if (curr_days > 0) {
				this.current_balance = curr_days + 'd ';
			}
			if (curr_hrs > 0) {
				this.current_balance = this.current_balance + curr_hrs + 'h ';
			}
			if (curr_mins > 0) {
				this.current_balance = this.current_balance + curr_mins + 'm';
			}

			this.current_balance = current_leave < 0 ? `- ${this.current_balance}` : this.current_balance;

			
			//Leave by the start date
			let lvby_days = 0 ;
			let lvby_hrs = 0;
			let lvby_mins = 0;
			let leavebydate = this.leaves.leave_by_date;

			const leavebydate_positive = Math.abs(leavebydate);
			lvby_days = Math.floor(leavebydate_positive / this.leaves.mins_per_day);
			
			const leavebydate_left = leavebydate_positive - (lvby_days * this.leaves.mins_per_day);

			lvby_hrs = Math.floor(leavebydate_left / 60);
			lvby_mins = leavebydate_left - (lvby_hrs * 60);
			

			if (lvby_days > 0) {
				this.leave_by_date = lvby_days + 'd ';
			}
			if (lvby_hrs > 0) {
				this.leave_by_date = this.leave_by_date + lvby_hrs + 'h ';
			}
			if (lvby_mins > 0) {
				this.leave_by_date = this.leave_by_date + lvby_mins + 'm';
			}

			this.leave_by_date = leavebydate < 0 ? `- ${this.leave_by_date}`: this.leave_by_date;

			//Now find the Leave requested days,hours and mins
			this.format_requested();
		},
		format_requested(){
			let leaverequested = 0;
			let lvreq_days = 0;
			let lvreq_hrs = 0;
			let lvreq_mins =0;

			const all_day = (this.date_start !== this.date_end && this.date_end) || (this.date_start === this.date_end && this.time_start.length === 0 && this.time_end.length === 0) ? true : false;
			const partial_leave = !all_day;

			if (partial_leave) {
				const time1_tmp = moment(`${this.date_start} ${this.time_start}`, 'YYYY-MM-DD h:mm a').toString();
				let time1 = new Date(time1_tmp);
				
				const time2_tmp = this.date_end ? moment(`${this.date_end} ${this.time_end}`, 'YYYY-MM-DD h:mm a').toString() : moment(`${this.date_start} ${this.time_end}`, 'YYYY-MM-DD h:mm a').toString();
				let time2 = new Date(time2_tmp);

				let time1m = time1.getTime(time1); //this will be in milliseconds
				let time2m = time2.getTime(time2);

				leaverequested = time2m-time1m;
				
				let lvmins = Math.floor(leaverequested/60000);
				lvreq_days = Math.floor(lvmins/this.leaves.mins_per_day);

				lvmins = lvmins - (lvreq_days*this.leaves.mins_per_day);
				lvreq_hrs = Math.floor(lvmins/60);
				lvreq_mins = lvmins - (lvreq_hrs*60);

			} else {
				leaverequested = this.leave_capacity;
				lvreq_days = Math.floor(leaverequested/this.leaves.mins_per_day);
				leaverequested = leaverequested*60*1000; //calculate back into milliseconds
			}

			// need to find leave_requested hours
			if (lvreq_days>0) {
				this.leave_requested = lvreq_days +'d ';
			}
			if (lvreq_hrs>0){
				this.leave_requested = this.leave_requested + lvreq_hrs +'h ';
			}
			if (lvreq_mins>0){
				this.leave_requested = this.leave_requested + lvreq_mins + 'm';
			}

			
			let remaining = this.leaves.leave_by_date;
			const remaining_positive = remaining;


			let rem_days = 0;
			let rem_hrs = 0;
			let rem_mins =0;
			let rem = remaining_positive - (leaverequested / 60000);

			if (rem < 0) {
				this.is_negative = true;
				rem = -rem;
			}
			
			rem_days = Math.floor(rem/this.leaves.mins_per_day);

			
			rem = rem - (rem_days*this.leaves.mins_per_day);
			rem_hrs = Math.floor(rem/60);
			rem_mins = rem - (rem_hrs*60);

			if (rem_days!=0) {
				this.leave_remaining = rem_days +'d ';
			}

			if (rem_hrs>0){
				this.leave_remaining = this.leave_remaining + rem_hrs +'h ';
			}
			if (rem_mins>0){
				this.leave_remaining = this.leave_remaining + rem_mins + 'm';
			}

			this.leave_remaining = this.leave_remaining;
		},
		reset_leave(){
			//this clears all leave fields
			this.loading = false;
			this.error_msg = '';
			this.date_start = moment().format("YYYY-MM-DD");
			this.date_end = moment().format("YYYY-MM-DD");
			this.time_start = '9:00 am';
			this.time_end = '5:00 pm';
			this.time_start_init = '9:00 am';
			this.time_end_init = '5:00 pm';
			this.event_type = null;
			this.isCalulate = false;
			this.leaves = null;
			this.current_balance = '8h';
			this.leave_by_date = '8h';
			this.leave_requested = '8h';
			this.leave_remaining = '8h';
			this.is_negative = false;
			this.leave_capacity = 0;
			this.hasdata = false;
		},
		create_leave(){
			this.isLeaveCreating  = true;
			// this.$router.push({ name: "Edit Leave", params: { id: 0 } });
		},
		_isCalulate() {
			let isCalulate = false;

			if (this.event_type && this.date_start !== null && this.date_start.length !== 0) {
				const all_day = this.date_end && this.date_start !== this.date_end ? true : false;

				if (all_day) {
					isCalulate = true;
				} else {
					const start_24_hour = this.time_start ? moment(this.time_start, 'h:mm a').format('HH:mm') : '';
					const end_24_hour = this.time_end ? moment(this.time_end, 'h:mm a').format('HH:mm') : '';

					if (start_24_hour.length !== 0 && end_24_hour.length !== 0 && start_24_hour < end_24_hour) {
						isCalulate = true;
					}
				}
			}

			return isCalulate;
		},
		_timeCheck(is_start){
			const time_start = this.time_start ? this.time_start: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(this.time_start, 'h:mm a');
				const time2 = moment(this.time_end, 'h:mm a');
				const budget = time2.diff(time1, 'minutes');
				
				if (budget < 0) {
					if (is_start) {
						this.start_time_error = true;
					} else {
						this.end_time_error = true;
					}
				} 
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.leavecalc {
	max-width: 500px;
	min-height:100%;
}
.columncolor {
	background: #D3D3D3;
	opacity:0.0;
}
#calc_label {
	padding-left: 5px;
	color: #757575;
}
#calc_content {
	padding-left: 5px; 
	color: #192A3E;
}
.leave-item-title {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
}

.leave-item-title-disable {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: rgba(55, 73, 95, 1);
	opacity: 0.5;
}

.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
</style>